import { render, staticRenderFns } from "./ModelNewStrategy.vue?vue&type=template&id=7c096920"
import script from "./ModelNewStrategy.vue?vue&type=script&lang=js"
export * from "./ModelNewStrategy.vue?vue&type=script&lang=js"
import style0 from "./ModelNewStrategy.vue?vue&type=style&index=0&id=7c096920&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports